export default __webpack_public_path__ + "static/media/paypal.4b6c50f0.svg";